module.exports = __webpack_public_path__ + "static/media/send.55569486.svg";